import type { JSX } from "react"

type StatCardProps = {
  className?: string
  description: string
  value: string | number
  small?: boolean
}

export const StatCard: React.FC<StatCardProps> = ({
  description,
  value,
  small = false,
  className = "",
}): JSX.Element | null => {
  return (
    <div>
      <div className={`${className} ${small ? "text-base" : "text-2xl"} text-accent-foreground`}>{value}</div>
      <div className={`${small ? "text-xs" : "text-sm"} text-muted-foreground`}>{description}</div>
    </div>
  )
}
